import _ from 'lodash';
import { FETCH_VIDEOS_TAB } from './VideosTabActions';

const INITIAL_PAGINATION_STATE = {
  nextPage: null,
  paginationItems: [],
  hasMoreItems: null,
  fetching: false,
};

const INITIAL_STATE = {
  videos: null,
  ...INITIAL_PAGINATION_STATE,
};

export default function(state = INITIAL_STATE, action) {
  if (!action.payload) {
    return state;
  }

  switch (action.type) {
    case FETCH_VIDEOS_TAB: {
      const videosData = _.get(action, 'payload.data.member');
      if (!videosData) return state;
      return {
        ...state,
        ...INITIAL_STATE,
        videos: { ...state.videos, [action.payload.config.url]: videosData },
      };
    }
    default:
      return state;
  }
}
